import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-contact-confirmation',
  standalone: true,
  imports: [],
  templateUrl: './contact-confirmation.component.html',
  styleUrls: ['./contact-confirmation.component.scss']
})
export class ContactConfirmationComponent {
  @Input() nombrePersona: string = 'Usuario';
  @Input() companyName: string = 'arq-it';

}
